



























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IBankId } from '@signing-page/signing/types/bankid';
import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import { InputType } from '@/enums/InputType';
import Icon from '@/components/Icon.vue';
import { EButtonTypes } from '@/enums/ButtonType.ts';
import { EBankIdSigningType } from '@signing-page/signing/types/enums/bankid-se.ts';

@Component({
  components: {
    Button,
    Input,
    Icon,
  },
  data: () => ({
    InputType,
    EButtonTypes,
  }),
})
export default class BankIdStart extends Vue {
  @Prop() bankId!: IBankId;
  @Prop() jwt!: string;

  type: EBankIdSigningType = EBankIdSigningType.None;

  handleSetQR(): void {
    this.type = EBankIdSigningType.QR;
    this.$emit('setQR');
  }

  handleSetSameDevice(): void {
    this.type = EBankIdSigningType.SameDevice;
    this.$emit('setSameDevice');
  }

  get qrIsLoading(): boolean {
    return this.bankId.isLoading && this.type === EBankIdSigningType.QR;
  }

  get sameDeviceIsLoading(): boolean {
    return this.bankId.isLoading && this.type === EBankIdSigningType.SameDevice;
  }
}
